export default "__VITE_ASSET__DzSQTxYv__"